import type {
	Components,
} from '@mui/material'

export const materialUITypographyComponentTheme: {
	components: Components
} = {
	components: {
		MuiTypography: {
			styleOverrides: {
				root: {
					color: 'var(--on-surface-color)',
				},
			},
			variants: [
				{
					props: {
						color: 'primary',
					},
					style: {
						color: 'var(--primary-color)',
					},
				},
				{
					props: {
						color: 'on-primary',
					},
					style: {
						color: 'var(--on-primary-color)',
					},
				},
				{
					props: {
						color: 'secondary',
					},
					style: {
						color: 'var(--secondary-color)',
					},
				},
				{
					props: {
						color: 'on-secondary',
					},
					style: {
						color: 'var(--on-secondary-color)',
					},
				},
				{
					props: {
						color: 'hint',
					},
					style: {
						color: 'var(--on-surface-color-hint)',
					},
				},
				{
					props: {
						color: 'on-surface',
					},
					style: {
						color: 'var(--on-surface-color)',
					},
				},
				{
					props: {
						color: 'error',
					},
					style: {
						color: 'var(--error-color)',
					},
				},
				{
					props: {
						color: 'success',
					},
					style: {
						color: 'var(--positive-color)',
					},
				},
				{
					props: {
						color: 'warning',
					},
					style: {
						color: 'var(--warning-color)',
					},
				},
			],
		},
	},
}
